import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-item',
  templateUrl: './single-item.component.html',
  styleUrls: ['./single-item.component.scss']
})
export class SingleItemComponent implements OnInit {

  @Input() block: any;
  @Input() lang: string = '';
  @Input() offerta_formativa_id: any;
  @Input() positionRowIdx: number = 0;

  constructor() { }

  ngOnInit(): void {}

}
